import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from "react";
import { useForm, Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuth } from "@lastmaj/saleor-sdk";
import { commonMessages, translateAuthMessages } from "@temp/intl";
import { Button } from "@components/atoms";
import { Notification, TextField } from "@components/molecules";
import SvgRedX from "images/SvgRedX";
import * as S from "./styles";

var LoginForm = function LoginForm() {
  var _useAuth = useAuth(),
      signIn = _useAuth.signIn;

  var _useForm = useForm(),
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      errors = _React$useState4[0],
      setErrors = _React$useState4[1];

  var onSubmit =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(formData) {
      var email, password, _ref2, data, dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = formData.email, password = formData.password;
              setErrors(null);
              setLoading(true);
              _context.next = 5;
              return signIn(email, password);

            case 5:
              _ref2 = _context.sent;
              data = _ref2.data;
              dataError = _ref2.dataError;
              setLoading(false);

              if (dataError === null || dataError === void 0 ? void 0 : dataError.error) {
                setErrors(dataError.error);
              } else if (data) {
                setErrors(null);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var intl = useIntl();
  return React.createElement("div", null, React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, errors && React.createElement(S.Notif, null, React.createElement(Notification, {
    title: translateAuthMessages(errors[0].code, intl).title,
    expl: translateAuthMessages(errors[0].code, intl).expl,
    color: "red",
    Svg: SvgRedX
  })), React.createElement(Controller, {
    control: control,
    name: "email",
    defaultValue: "",
    rules: {
      required: {
        value: true,
        message: "Ce champ est obligatoire"
      }
    },
    render: function render(_ref3) {
      var _ref3$field = _ref3.field,
          value = _ref3$field.value,
          onChange = _ref3$field.onChange,
          error = _ref3.fieldState.error;
      return React.createElement(TextField, {
        name: "email",
        onChange: onChange,
        value: value,
        autoComplete: "email",
        label: intl.formatMessage(commonMessages.eMail),
        type: "email",
        errors: error && [error]
      });
    }
  }), React.createElement(Controller, {
    control: control,
    name: "password",
    defaultValue: "",
    rules: {
      required: {
        value: true,
        message: "Ce champ est obligatoire"
      }
    },
    render: function render(_ref4) {
      var _ref4$field = _ref4.field,
          value = _ref4$field.value,
          onChange = _ref4$field.onChange,
          error = _ref4.fieldState.error;
      return React.createElement(TextField, {
        name: "password",
        value: value,
        onChange: onChange,
        autoComplete: "password",
        label: intl.formatMessage(commonMessages.password),
        type: "password",
        errors: error && [error]
      });
    }
  }), React.createElement("div", null, React.createElement(Button, _extends({
    testingContext: "submit",
    type: "submit"
  }, loading && {
    disabled: true
  }), React.createElement(FormattedMessage, commonMessages.login)))));
};

export default LoginForm;